import { useEffect, useRef, useState } from "react";
import { Play, Pause, SkipForward } from "lucide-react";

const PLAYLIST = [
  {
    name: "Arankai — Convince Me",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/8f25db5746b911f8_Arankai%20%27Convince%20Me%27%20%28Official%20Music%20video%29.mp3",
  },
  {
    name: "Phix — Without You",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/6492ece2222c9d53_Phix%20-%20WITHOUT%20YOU%20-%20%28Official%20Music%20Video%29.mp3",
  },
  {
    name: "Phix — Bonnie & Clyde",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/9be5239818b7723b_Phix%20-%20BONNIE%20%26%20CLYDE%20-%20%28Official%20Music%20Video%29.mp3",
  },
  {
    name: "Arankai — Conquer (feat. Josh Mowery)",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/137dfcffe762ed3d_Arankai%20-%20Conquer%20%28Feat.%20Josh%20Mowery%20of%20Catch%20Your%20Breath%29%20-%20Official%20Music%20Video.mp3",
  },
  {
    name: "Jelly Roll — I Am Not Okay",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/9736dabfd184cd3d_Jelly%20Roll%20-%20I%20Am%20Not%20Okay%20%28Official%20Lyric%20Video%29.mp3",
  },
  {
    name: "Jelly Roll — Save Me",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/892d53e0eb0fe346_Jelly%20Roll%20-%20Save%20Me%20%28New%20Unreleased%20Video%29.mp3",
  },
  {
    name: "Jelly Roll — Need a Favor",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/9f51804cb2e161fc_Jelly%20Roll%20-%20NEED%20A%20FAVOR%20%28Official%20Music%20Video%29.mp3",
  },
  {
    name: "Jelly Roll — Thorns",
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/b12f908424869bda_Jelly%20Roll%20-%20Thorns%20%28Official%20Music%20Video%29.mp3",
  },
];

export const MusicPlayer = () => {
  const [playing, setPlaying] = useState(false);
  const [trackName, setTrackName] = useState(PLAYLIST[0].name);
  const audioRef = useRef(null);
  const trackRef = useRef(0);

  const start = async () => {
    if (!audioRef.current) {
      const audio = new Audio(PLAYLIST[0].src);
      audio.volume = 0.5;
      audio.addEventListener("ended", () => {
        trackRef.current = (trackRef.current + 1) % PLAYLIST.length;
        audio.src = PLAYLIST[trackRef.current].src;
        setTrackName(PLAYLIST[trackRef.current].name);
        audio.play().catch(() => setPlaying(false));
      });
      audioRef.current = audio;
    }
    try {
      await audioRef.current.play();
      setPlaying(true);
    } catch {
      setPlaying(false);
    }
  };

  const stop = () => {
    if (audioRef.current) audioRef.current.pause();
    setPlaying(false);
  };

  const skip = () => {
    if (!audioRef.current) return;
    trackRef.current = (trackRef.current + 1) % PLAYLIST.length;
    audioRef.current.src = PLAYLIST[trackRef.current].src;
    setTrackName(PLAYLIST[trackRef.current].name);
    if (playing) audioRef.current.play().catch(() => setPlaying(false));
  };

  useEffect(() => {
    // Try true autoplay; if the browser blocks it, start on first click anywhere.
    start();
    const autostart = (e) => {
      if (e.target.closest('[data-testid="music-toggle-button"], [data-testid="music-skip-button"]')) return;
      if (!playing) start();
    };
    window.addEventListener("pointerdown", autostart);
    return () => {
      window.removeEventListener("pointerdown", autostart);
      if (audioRef.current) audioRef.current.pause();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-2">
      {playing && (
        <span
          data-testid="now-playing-label"
          className="hidden sm:block max-w-[220px] truncate px-4 py-2.5 rounded-full bg-[#26153F] border border-[#3B2760] text-[#2DE2E6] text-xs font-bold mono-lbl"
        >
          ♪ {trackName}
        </span>
      )}
      <button
        data-testid="music-skip-button"
        onClick={skip}
        aria-label="Skip to next track"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#26153F] text-white border border-[#3B2760] shadow-lg hover:bg-[#3B2760] transition-colors"
      >
        <SkipForward className="w-5 h-5" />
      </button>
      <button
        data-testid="music-toggle-button"
        onClick={() => (playing ? stop() : start())}
        aria-label={playing ? "Pause background music" : "Play background music"}
        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FF2E88] text-white shadow-lg hover:bg-[#D61F73] transition-colors"
      >
        {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
    </div>
  );
};
